var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.438228 4.70689L2.37769 6.64639C2.47145 6.74013 2.5986 6.79279 2.73118 6.79279C2.86376 6.79279 2.99091 6.74013 3.08468 6.64639C3.17841 6.55263 3.23107 6.42548 3.23107 6.29289C3.23107 6.16031 3.17841 6.03316 3.08468 5.93939L1.30721 4.16289H11.5C11.6326 4.16289 11.7598 4.11021 11.8536 4.01645C11.9473 3.92268 12 3.7955 12 3.66289C12 3.53029 11.9473 3.40311 11.8536 3.30934C11.7598 3.21557 11.6326 3.16289 11.5 3.16289H1.27671L3.08468 1.35339C3.17841 1.25963 3.23107 1.13248 3.23107 0.999893C3.23107 0.867311 3.17841 0.740157 3.08468 0.646393C2.99091 0.552658 2.86376 0.5 2.73118 0.5C2.5986 0.5 2.47145 0.552658 2.37769 0.646393L0.437728 2.58589C0.157381 2.86764 0 3.24893 0 3.64639C0 4.04386 0.157381 4.42515 0.437728 4.70689H0.438228Z",
    fill: "#0090D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.5f9cc0d1de8accf83a20629f2fd5cd96.svg";
export { ForwardRef as ReactComponent };